export default "__VITE_ASSET__Do7CIo3x__"